module.exports = __webpack_public_path__ + "img/ring_skip_skip_0_0.5403384e.png";